export default __webpack_public_path__ + "static/media/settings-icon-na.a7f23c34.svg";